import React from "react";
import {
  Checkbox,
  TableHeadProps as ChakraTHeadProps,
  Th,
  Thead as ChakraTHead,
  Tr,
  VisuallyHidden
} from "@chakra-ui/react";
import { types } from "../../duck";

interface THeadProps extends ChakraTHeadProps {
  columns: types.ColumnProps[];
  theadHidden?: boolean;
  onSelectAll?: (selectAll: boolean) => void;
  isAllSelected: boolean;
  isIndeterminate: boolean;
}

const Thead: React.FC<THeadProps> = ({
  columns,
  theadHidden,
  onSelectAll,
  isIndeterminate,
  isAllSelected,
  ...rest
}) => {
  return (
    <ChakraTHead bg="gray.200" {...rest}>
      <Tr>
        {onSelectAll && (
          <Th w="14">
            <Checkbox
              colorScheme="dark"
              borderColor="dark.500"
              isChecked={isAllSelected}
              isIndeterminate={isAllSelected ? false : isIndeterminate}
              onChange={e => {
                onSelectAll(e.target.checked);
              }}
            />
          </Th>
        )}
        {columns.map(({ label, w, sticky }, i) => {
          const theadLabel = theadHidden ? (
            <VisuallyHidden>{label}</VisuallyHidden>
          ) : (
            label
          );

          return (
            <Th
              key={i}
              fontWeight="bold"
              fontSize="sm"
              lineHeight="4"
              color="gray.700"
              letterSpacing="0.05em"
              textTransform="initial"
              whiteSpace="nowrap"
              py={theadHidden ? 0 : 5}
              w={w}
              position={sticky ? "sticky" : "static"}
              left={sticky ? 0 : "auto"}
              bg={sticky ? "gray.200" : "initial"}
            >
              {theadLabel}
            </Th>
          );
        })}
      </Tr>
    </ChakraTHead>
  );
};

export default Thead;
